import BaseRepository from '@/baseRepository/BaseRepository';
const resource = `/api/v1/usernotifications`;
const notifiesResource = `/api/v1/notifies`;
const informGrpResource = `/api/v1/informmessaginggroups`;
const informMessagesResource = `/api/v1/informmessages`;
const InformMessageDeliveryBySMSesResource = "/api/v1/informmessagedeliverybysmses";
export default {
  getunseenUserNotification(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/unseen`, {
      baseURL,
      headers,
      params,
    });
  },
  getUserNotification(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}`, {
      baseURL,
      headers,
      params,
    });
  },
  recieveUserNotification(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(
      `${resource}/recieve`,
      {},
      {
        baseURL,
        headers,
        params,
      }
    );
  },
  seenUserNotification(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(
      `${resource}/seen`,
      {},
      {
        baseURL,
        headers,
        params,
      }
    );
  },
  sendApiCallErrorNotifies(body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(
      `${notifiesResource}/notify-client-api-call-error`,
      body,
      {
        baseURL,
        headers,
        params,
      }
    );
  },
         deleteInformMessageById(id,baseURL = {}, headers = {}) {
    return BaseRepository.delete(`${informMessagesResource}/${id}`, {
      baseURL,
      headers,
      id,
    });
  },
    getInformMessageById(id,baseURL = {}, headers = {}) {
    return BaseRepository.get(`${informMessagesResource}/${id}`, {
      baseURL,
      headers,
      id,
    });
  },
      makeReadyInformMessage(informmessagid,merchantId,  baseURL = {}, headers = {}) {
        return BaseRepository.post(`${InformMessageDeliveryBySMSesResource}/${informmessagid}/${merchantId}/add-by-merchant`, {},{
      baseURL,
      headers,
      informmessagid,
      merchantId,
    });
  },
      ///api/v1/informmessagedeliverybysmses/{informmessagid}/{merchantid}/add-by-merchant
           sendInformMessage(deliveryId,baseURL = {}, headers = {}) {
        return BaseRepository.post(`${InformMessageDeliveryBySMSesResource}/${deliveryId}/send`, {},{
      baseURL,
      headers,
      deliveryId,
    });
  },
          deleteInformMessageUsers(inforMessageid,userId,baseURL = {}, headers = {}) {
    return BaseRepository.delete(`${informMessagesResource}/delete-recptor/${inforMessageid}/${userId}`, {
      baseURL,
      headers,
      inforMessageid,
      userId,
    });
  },  
  getInformMessageSmsResultByResultId(id,baseURL = {}, headers = {},params = {}) {
    return BaseRepository.get(`${InformMessageDeliveryBySMSesResource}/getlistbyid/${id}/by-merchant`, {
      baseURL,
      headers,
      id,
      params,
    });
  },
    getAllInformMessagingGroup(baseURL = {}, headers = {}, params ={}) {
    return BaseRepository.get(`${informGrpResource}/byadmin`,{
      baseURL,
      headers,
      params,
    });
  },
       getInformGroupById(baseURL = {}, headers = {}, id) {
    return BaseRepository.get(`${informGrpResource}/${id}`, {
      baseURL,
      headers,
      id,
    });
  },
            getInformMessages(baseURL = {}, headers = {}, params ={},id,merchantId) {
    return BaseRepository.get(`${informMessagesResource}/${id}/by-merchant/${merchantId}`,{
      baseURL,
      headers,
      params,
      id,
      merchantId,
    });
  },
      addNewInformMessageByMerchant(merchantid, body, baseURL = {}, headers = {}, params = {}) {
        return BaseRepository.post(
          `${informMessagesResource}/${merchantid}/by-merchant`,body,
          {
            baseURL,
            headers,
            params,
            merchantid,
          }
        );
  }, 
            ///api/v1/informmessages/{groupId}/by-merchant/{merchantid}
};
